import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Offre } from '../_models/offre';
import { Page } from '../_models/page';


@Injectable({
  providedIn: 'root'
})

export class PageService {
  constructor(private http: HttpClient) {
  }

  getOnePage(id: number) {
    return this.http.get<Page>(`${environment.api}/api/pages/`+id);
  }

}
